import React, { useState } from 'react'
import styles from "./newFeedback.module.css"
import Button from "../../button";
import ConfettiExplosion from 'react-confetti-explosion';
import { CreateNewReview } from '../../../utils/reviews';
import {notify} from "../../toast"

const NewFeedback = (props) => {
    const [isFinished, setIsFinished] = useState(false)
    const [textValue, setTextValue] = useState("")

    const onSubmitHandler = async() => {

        if(textValue.length < 6)return notify("Per trumpas atsiliepimas", "warning");

        try {
            const response = await CreateNewReview({
                project_id:process.env.REACT_APP_PROJECT_ID,
                comment: textValue,
                client_data: "+37067837730"
            })

            if(!response.status || !response.data) throw new Error(response.message);

            setIsFinished(true)
            setTimeout(() => {
                return props.onRefresh()
            }, 1600);

        } catch (error) {
            return notify(error.message, "error");
        }

    }

    return (
        <div className={styles.container}>
            <h1 className={styles.header}>{isFinished ? "Dėkojame!" : "Palikite atsiliepimą"}</h1>
            {isFinished && <h2 style={{ color:"#94A7AE" }}>Lauksime sugrįžtant</h2>}

            {
                !isFinished ? 

                <div className={styles.body}>
                    <textarea
                    onChange={(text)=>{setTextValue(text.target.value)}}
                        autoFocus
                        rows="7"
                        placeholder='...'
                    >
                        
                    </textarea>
                    <Button onClick={onSubmitHandler}>
                        Pateikti
                    </Button>
                </div>

                :
                
                <div className={styles.congrats}>
                    {true && <ConfettiExplosion zIndex={5} />}
                </div>
            }

        </div>
    )
}

export default NewFeedback